<div class="flex flex-col gap-2 flex-wrap">
  @if (label(); as label) {
  <app-label [required]="required()">{{ label }}</app-label>
  } @if (hint(); as hint) {
  <app-hint>{{ hint }}</app-hint>
  }

  <!-- 부스 신청 전용 UI -->
  @if (isBoothApplication()) {
  <div class="flex flex-col gap-4">
    @if (isLoading()) {
    <app-spinner class="z-10" />
    } @else {

    <!-- 업로드 버튼 영역 - items().length === 0 일 때만 표시 -->
    @if (items().length === 0) {
    <div
      class="flex items-center gap-3 p-4 bg-gray-50 rounded-lg border-dashed border-2 border-zinc-200 w-full justify-center"
    >
      @if (items().length < maxlength()) {
      <button
        type="button"
        class="cursor-pointer inline-flex items-center justify-center gap-2 px-2 py-1 bg-primary-500 text-white text-sm font-medium rounded-lg"
        (click)="onClick()"
      >
        파일 선택
      </button>
      <button
        type="button"
        class="inline-flex items-center justify-center gap-1 px-2 py-1 text-zinc-400 text-sm font-medium"
        (dragover)="onDragOver($event)"
        (dragleave)="onDragLeave($event)"
        (drop)="onDragDrop($event)"
      >
        파일 드래그&드롭
        <app-icon
          name="material-symbols:add-circle-outline"
          class="size-4! text-zinc-400"
        />
      </button>
      }
    </div>
    }

    <!-- 파일 리스트 -->
    @if (items().length > 0) {
    <div class="flex flex-col gap-2">
      @for (item of items(); track $index) {
      <div
        class="flex items-center gap-2 text-sm w-full border rounded-lg border-zinc-200 p-2"
      >
        <button
          type="button"
          (click)="deleteFile(item.url)"
          class="cursor-pointer flex items-center"
        >
          <app-icon name="ic:outline-close" class="size-4! text-primary-500" />
        </button>
        <span class="text-zinc-600 text-sm font-medium">{{
          item.filename
        }}</span>
      </div>
      }
    </div>
    } }
  </div>
  } @else {

  <!-- 기존 UI -->
  <div
    class="flex w-full gap-6"
    [class.flex-row]="direction() === 'row'"
    [class.flex-col]="direction() === 'column'"
  >
    @if (isLoading()) {
    <app-spinner class="z-10" />
    } @else { @if (items().length < maxlength()) {
    <div class="flex flex-col w-full gap-2">
      <div
        class="p-4 min-w-[20rem] gap-4 border-2 border-gray-200 border-dashed rounded-lg flex flex-col items-center justify-center hover:border-primary-500 hover:bg-primary-50 transition-all cursor-pointer"
        [ngClass]="{
          'min-h-75': direction() === 'row',
        }"
        [class]="
          isDragOvered()
            ? 'bg-primary-50 border-primary-500'
            : 'bg-white border-gray-200'
        "
        (click)="onClick()"
        (dragover)="onDragOver($event)"
        (dragleave)="onDragLeave($event)"
        (drop)="onDragDrop($event)"
      >
        <app-icon
          name="ic:baseline-upload-file"
          class="size-8! text-primary-500"
        />
        <div class="flex flex-col gap-1 text-center">
          <p class="text-sm text-gray-800">
            {{ type() === 'image' ? '사진' : '파일' }}을 선택하거나 끌어다 놓기
          </p>
          @if (placeholder()) {
          <p class="text-sm text-gray-500">
            {{ placeholder() }}
          </p>
          }
        </div>
      </div>
      @if (maxlength() > 1) {
      <div class="flex w-full text-sm text-gray-500">
        <p>{{ value().length }} / {{ maxlength() }}</p>
      </div>
      }
    </div>
    } @if (items(); as items) { @if (items.length > 0) {
    <div
      cdkDropList
      [cdkDropListData]="items"
      [cdkDropListDisabled]="items.length < 2"
      (cdkDropListDropped)="onDrop($event)"
      class="flex flex-col gap-2 max-h-80 min-w-60"
    >
      @for (item of items; track $index) {
      <div
        cdkDrag
        class="flex w-full justify-between p-2.5 gap-2.5 bg-white border border-gray-200 rounded-md"
      >
        <div class="flex gap-2.5 items-center">
          @if (type() === "image") { @if (item.status) {
          <img
            [src]="item.url"
            class="file-uploader-thumbnail rounded-md cursor-pointer w-9 h-9"
            (click)="openImage(item.url)"
            (error)="item.status = 'fail'"
          />
          } @else {
          <div
            class="flex items-center justify-center p-2 border border-gray-200 rounded-md w-9 h-9"
          >
            <app-icon name="mdi:file-image" class="block w-6 h-6 bg-gray-700" />
          </div>
          } } @else {
          <app-icon
            name="ic:outline-insert-drive-file"
            class="block w-6 h-6 bg-gray-700"
          />
          }
          <div class="flex flex-col gap-1">
            <p
              [ngClass]="{
                'max-w-28': direction() === 'row',
              }"
              class="w-full truncate max-w-40 lg:max-w-100 text-sm text-gray-700"
            >
              {{ item.filename }}
            </p>
          </div>
        </div>
        <div class="flex items-center gap-4">
          @if (item.status === "fail") {
          <app-icon
            class="w-5 h-5 text-red-500"
            name="ic:round-warning-amber"
          />
          } @if (item.status === "success") {
          <app-icon class="w-5 h-5 text-primary-500" name="ic:baseline-check" />
          } @if (!item.status) {
          <app-icon
            class="w-5 h-5 text-primary-500 animate-spin"
            name="mdi:loading"
          />
          } @if (item.status) {
          <app-icon
            name="ic:outline-close"
            class="w-5 h-5 text-gray-700 cursor-pointer"
            (click)="deleteFile(item.url)"
          />
          }
        </div>
      </div>
      }
    </div>
    } } }
  </div>
  }
</div>
<input
  #inputRef
  class="hidden"
  id="app-file-uploader"
  type="file"
  multiple
  [accept]="accept()"
/>
